/**
 * @generated SignedSource<<83e213db3e572fcb740f525f2fc05c0c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespAboutItemPanel_viewer$data = {
  readonly isDyoEnabled: boolean | null;
  readonly " $fragmentType": "PdpRespAboutItemPanel_viewer";
};
export type PdpRespAboutItemPanel_viewer$key = {
  readonly " $data"?: PdpRespAboutItemPanel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutItemPanel_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespAboutItemPanel_viewer",
  "selections": [
    {
      "alias": "isDyoEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "designYourOwn"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"designYourOwn\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "16d102aa4c746530446de9287d06c685";

export default node;
